/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { AgentResource } from './agentResource';


export interface AgentPairingRequest { 
    /**
     * Agent ID
     */
    agent_id: string;
    /**
     * Agent Version
     */
    agent_version: string;
    /**
     * Agent display name
     */
    agent_display_name?: string;
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
    resource: AgentResource;
}
export namespace AgentPairingRequest {
}


